import React from "react";
import StarRating from "./StarRating";
import className from "classnames";
import { Plan, StarRating as StarRatingType } from "../@types";
import { OriginalMedicareStarRatings } from ".";

export interface PlanStarRatingRowProps {
  color?: string;
  label?: string;
  size?: string;
  starRating?: StarRatingType;
  onClick: () => void;
  open: boolean;
  summary?: string;
  ariaLabel?: string;
  showOriginalMedicareStars?: boolean;
  plan: Plan;
}

const PlanStarRatingRow: React.FunctionComponent<PlanStarRatingRowProps> = props => {
  let stars = null;
  const color = props.color || "white";

  if (typeof props.starRating !== "undefined" && props.size !== "large") {
    stars = (
      <StarRating
        stars={props.starRating}
        includeLabel={false}
        planYear={props.plan.contract_year}
      />
    );
  }

  return (
    <div className="PlanStarRatingRow">
      <button
        className={`PlanStarRatingRow__header PlanStarRatingRow__header--${color}`}
        data-testid="rating-row-button"
        onClick={props.onClick}
        aria-expanded={props.open}
      >
        <div className="ds-u-display--flex mct-u-full-width">
          <i
            className={className(
              "ds-u-margin-right--1",
              { "fas fa-plus ": !props.open },
              { "fas fa-minus": props.open }
            )}
          />
          <div className="ds-u-display--flex ds-u-flex-wrap--wrap ds-u-md-flex-wrap--nowrap ds-u-justify-content--between mct-u-full-width">
            <h2
              data-testid="rating-row-label"
              className={className("PlanStarRatingRow__label", {
                [`PlanStarRatingRow__label--${props.size}`]: !!props.size,
              })}
              aria-label={props.ariaLabel}
            >
              {props.label}
            </h2>
            {stars}
          </div>
        </div>
      </button>
      {props.open && props.showOriginalMedicareStars && (
        <div className="ds-u-text-align--right ds-u-padding-top--2">
          <OriginalMedicareStarRatings plan={props.plan} />
        </div>
      )}
      {props.open && props.summary && (
        <div className="PlanStarRatingRow__header PlanStarRatingRow__header--white ds-u-display--flex ds-u-flex-wrap--wrap ds-u-justify-content--between">
          <h2
            className={className("PlanStarRatingRow__label", {
              [`PlanStarRatingRow__label--${props.size}`]: !!props.size,
            })}
          >
            {props.summary}
          </h2>
          <StarRating
            stars={props.starRating}
            includeLabel={false}
            planYear={props.plan.contract_year}
          />
        </div>
      )}
      {props.open && <div data-testid="row-children">{props.children}</div>}
    </div>
  );
};

export default PlanStarRatingRow;
